import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "pcg-ng-help-button",
    templateUrl: "help-button.component.html"
})
export class HelpButtonComponent implements OnInit, AfterViewInit {
    @Input() public title: string;
    @Input() public content: string;

    public ngOnInit(): void {
    }

    public ngAfterViewInit(): void {
        const bookletHelpBtn = $(".js-help-button");
        bookletHelpBtn.popover();
    }
}
